module.exports = __webpack_public_path__ + "9854c36138c2880f36f0e39fe608b174.svg";